import { render, staticRenderFns } from "./telawint.vue?vue&type=template&id=6cca7e72&scoped=true&"
import script from "./telawint.vue?vue&type=script&lang=js&"
export * from "./telawint.vue?vue&type=script&lang=js&"
import style0 from "./telawint.vue?vue&type=style&index=0&id=6cca7e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca7e72",
  null
  
)

export default component.exports